import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { UserService, UserState } from '../../services/user-service/user.service';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, ShoppingBag, Search, Home, Package2, FileUser, Settings2  } from 'lucide-angular';

@Component({
  selector: 'app-admin-layout',
  imports: [RouterOutlet,CommonModule, LucideAngularModule, RouterLink],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent implements OnInit{

  readonly homeIcon = Home;
  readonly productIcon = ShoppingBag;
  readonly orderIcon = Package2;
  readonly customerIcon = FileUser;
  readonly settingsIcon = Settings2;

  sidebarOpen = localStorage.getItem('sidebarOpen') === 'true';
  sidebarOptions = [
    {title: 'Dashboard', icon: Home, link: '/admin/dashboard', isActive: true},
    {title: 'Products', icon: this.productIcon, link: '/admin/products', isActive: false},
    {title: 'Orders', icon: this.orderIcon, link: '/admin/orders', isActive: false},
    {title: 'Customers', icon: this.customerIcon, link: '/admin/customers', isActive: false},
    {title: 'Settings', icon: this.settingsIcon, link: '/admin/settings', isActive: false},
    {title: 'logout', icon: this.settingsIcon, link: '/logout', isActive: false}
  ];


  user:UserState | undefined = undefined;
  constructor(private userService: UserService, private router: Router) {
    this.router.events.subscribe((val: any) => {
      this.sidebarOptions.forEach(option => {
        option.isActive = option.link.split('/')[2] === val?.urlAfterRedirects.split('/')[2];
      });
    });
  }

  ngOnInit(): void {
    this.user = this.userService.getUserState();
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    console.log(this.sidebarOpen);

    localStorage.setItem('sidebarOpen', this.sidebarOpen ? 'true' : 'false');
  }
}
